import React from 'react'
import styled from 'styled-components'

import {
  useWalletsAssetBalance,
  useWalletsAssetBalanceUsd,
} from '@root/entities/wallet/hooks'
import { AmountFormatted } from '@root/shared/core/format'

import type { PairModel } from '@root/entities/pair'

type FavoriteHoldingCellProps = {
  value: PairModel
}

export const FavoriteHoldingCell: React.FC<FavoriteHoldingCellProps> =
  React.memo(({ value }) => {
    const userHolding = useWalletsAssetBalance({
      currency: value.quote,
    })
    const userHoldingUsd = useWalletsAssetBalanceUsd({
      currency: value.quote,
    })

    return (
      <Root>
        <AmountFormatted amount={userHolding} roundingMode="trunc" />
        <BallanceUsd>
          <AmountFormatted
            amount={userHoldingUsd}
            currency="$"
            roundingMode="trunc"
          />
        </BallanceUsd>
      </Root>
    )
  })

const Root = styled.div`
  color: var(--text-11);

  display: grid;

  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`

const BallanceUsd = styled.span`
  color: var(--text-9);
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
`
